import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BlgFormControls } from '../../models/blg-form-controls.model';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import {
  ApiVisa,
  BranchContainerModel, CashbookContainerModel,
  CompanyContainerModel,
  EntityContainerModel, GlcodeContainerModel,
  LocationContainerModel
} from 'blg-akaun-ts-lib';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

@Component({
  selector: 'blg-single-column-form',
  templateUrl: './single-column-form.component.html',
  styleUrls: ['./single-column-form.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class SingleColumnFormComponent implements OnInit {

  @Input() apiVisa: ApiVisa;
  @Input() controls: BlgFormControls[] = [];
  @Input() form = new FormGroup({});

  @Output() formChange = new EventEmitter<FormGroup>();
  // @Output() selectedCompany = new EventEmitter<CompanyContainerModel>();
  // @Output() selectedBranch = new EventEmitter<BranchContainerModel>();
  // @Output() selectedSupplier = new EventEmitter<EntityContainerModel>();
  // @Output() selectedCustomer = new EventEmitter<EntityContainerModel>();
  // @Output() selectedLocation = new EventEmitter<LocationContainerModel>();
  // @Output() selectedCashbook = new EventEmitter<CashbookContainerModel>();
  // @Output() selectedGlcode = new EventEmitter<GlcodeContainerModel>();

  ngOnInit() {
    this.controls.forEach(param => {
      const required = param.required ? Validators.required : null;
      this.form.addControl(
        param.formControl,
        new FormControl('', required)
      );
    });
    this.formChange.emit(this.form);
  }

  onCompanySelected(e) {
    // this.selectedCompany.emit(e);
  }

  onBranchSelected(e) {
    // this.selectedBranch.emit(e);
  }

  onSupplierSelected(e) {
    // this.selectedSupplier.emit(e);
  }

  onCustomerSelected(e) {
    // this.selectedCustomer.emit(e);
  }

  onLocationSelected(e) {
    // this.selectedLocation.emit(e);
  }

  onCashbookSelected(e) {
    // this.selectedCashbook.emit(e);
  }

  onGlcodeSelected(e) {
    // this.selectedGlcode.emit(e);
  }
}
